import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { LoadingService } from '@app-shared/services/loading.service';
import { NzSpinModule } from 'ng-zorro-antd/spin';

@Component({
  selector: 'lib-loading',
  imports: [CommonModule, NzSpinModule],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss',
})
export class LoadingComponent {
  currentLoadingStatus: boolean = false;
  constructor(private loadingService: LoadingService) {
    this.loadingService.currentLoadingStatus.subscribe((value) => {
      this.currentLoadingStatus = value;
    });
  }
}
